export const listColumnsSize = {
  title: 6,
  actions: 3,
};
